import * as PIXI from "pixi.js";
import PIXISpine from "Plugins/pixi-spine";

import ShakaMinionParticle from "Game/PixiCores/Particles/ShakaMinion/ShakaMinionParticle.js";
import { Tween, Tweener } from "Classes/Tween";
import * as Sentry from "@sentry/react";

const character = {
  controller: {},
  scale: 0.2,
  sequence: {
    idle: [{ name: "Idle", loop: true }],
    move: [{ name: "Move", loop: true }],
    charge: [
      { name: "Charging", loop: false },
      { name: "ChargingLoop", loop: true, delay: 0 },
    ],
    attack: [
      { name: "Attack", loop: false },
      { name: "Idle", loop: true, delay: 0 },
    ],
    attackOnce: [
      { name: "Charging", loop: false },
      { name: "Attack", loop: false, delay: 0 },
      { name: "Idle", loop: true, delay: 0 },
    ],
    hit: [
      { name: "Hit", loop: false },
      { name: "Idle", loop: true, delay: 0 },
    ],
    win: [{ name: "Win", loop: true }],
    lose: [{ name: "Lose", loop: false }],
  },
  skins: ["Zubu", "Zeke", "Zulu"],
  event: {
    Attack: () => {
      //   character.controller.setFiredBulletTo(
      //     character.controller.targetPosition
      //   );
    },
  },
  eventListener: {
    event: (entry, { data }) => {
      const { name } = data;
      character.event[name]?.();
    },
  },
  playSequence: (spine, sequenceData) => {
    if (!sequenceData || sequenceData.length === 0) return;
    spine.state.setAnimation(0, sequenceData[0].name, sequenceData[0].loop);
    for (let i = 1; i < sequenceData.length; i++)
      spine.state.addAnimation(
        0,
        sequenceData[i].name,
        sequenceData[i].loop,
        sequenceData[i].delay
      );
  },
  create: (app, audioRef, path) => {
    return new Promise((resolve, reject) => {
      let promises = [
        new Promise((resolve, reject) => {
          const preload = new PIXI.Loader();
          preload.add(
            "character",
            // process.env.REACT_APP_API_URL_GO_CHARACTER + "/BANDITS/Bandits.json"
            path
          );
          preload.load(async (loader, resources) => {
            let spineData = resources["character"].spineData;
            if (spineData) {
              let spine = new PIXISpine.Spine(spineData);
              spine.scale.set(character.scale);
              spine.state.addListener(character.eventListener);
              spine.skeleton.setSkinByName("Zeke");
              let container = new PIXI.Container();
              let containerParticle = new PIXI.Container();
              let containerSmoke = new PIXI.Container();
              let emitterController;

              container.addChild(spine);
              container.addChild(containerParticle);
              container.addChild(containerSmoke);

              //   await TenkoMinionParticle.load(
              //     app,
              //     containerParticle,
              //     "Aka",
              //     containerSmoke
              //   ).then((particle) => {
              //     emitterController = particle;
              //   });

              await ShakaMinionParticle.load(containerParticle, "Zeke").then(
                (particle) => {
                  emitterController = particle;
                }
              );

              const controller = {
                spine,
                container,
                emitterController,
                targetPosition: {
                  x: 0,
                  y: 0,
                },
                infoCharacter: {
                  characterName: "Zeke",
                },
                setTargetPosition: (x, y) => {
                  character.controller.targetPosition = {
                    x: x,
                    y: y,
                  };
                },
                setDisappearedParticleActive: () => {
                  new Tweener(app.ticker)
                    .insert(
                      0.0,
                      new Tween(1, (pos, dt) => {
                        if (pos === 0) {
                        }
                        if (pos === 1) {
                          //   emitterController.disappeared.container.visible = false;
                          //   emitterController.disappeared.emitter.emit = false;
                        } else {
                          //   emitterController.disappeared.container.visible = true;
                          //   emitterController.disappeared.emitter.emit = true;
                          //   emitterController.disappeared.emitter.update(dt);
                          //   emitterController.disappeared.container.alpha =
                          //     1 - pos ** (1 / 2) * 1;
                          //   emitterController.disappeared.container.scale.set(
                          //     0 + pos ** (1 / 4) * 5
                          //   );
                        }
                      })
                    )
                    .play();
                },
                setFiredBulletTo: async (targetPosition) => {
                  emitterController.weapon.position.set(0);
                  new Tweener(app.ticker)
                    .insert(
                      0.8,
                      new Tween(0.5, (pos, dt) => {
                        if (pos === 0) {
                          if (audioRef.current._group["ENM-014"]) {
                            audioRef.current._group["ENM-014"]._list[0].play(
                              "attack"
                            );
                          }
                          containerParticle.visible = true;
                          emitterController.weapon.visible = true;
                        }
                        if (pos === 1) {
                          if (audioRef.current._group["ENM-014"]) {
                            audioRef.current._group["ENM-014"]._list[0].play(
                              "hitTargetNormal"
                            );
                          }
                          emitterController.weapon.position.set(0);
                          emitterController.weapon.angle = 0;
                          emitterController.weapon.visible = false;
                        } else {
                          emitterController.weapon.angle -= 30;
                          emitterController.weapon.position.set(
                            -100 + pos * (targetPosition.x + 100),
                            -100
                          );
                        }
                      })
                    )
                    .play();
                  await character.controller.routineWait(1.3).then(() => {
                    console.log("particle hit");
                  });
                },
                setActive: (isActive) => {
                  container.visible = isActive;
                  containerParticle.visible = false;
                },
                setSkin: (skinName) => {
                  if (character.skins.indexOf(skinName) < 0) {
                    return false;
                  } else {
                    const skeleton = controller.spine.skeleton;
                    skeleton.setSkin(null);
                    skeleton.setSkinByName(skinName);
                    return true;
                  }
                },
                randomSkin: () => {
                  let index = Math.floor(
                    Math.random() * character.skins.length
                  );
                  controller.setSkin(character.skins[index]);
                },
                playState: (stateName) => {
                  if (character.sequence[stateName])
                    character.playSequence(
                      controller.spine,
                      character.sequence[stateName]
                    );
                },
                destroy: () => {
                  controller.spine?.destroy();
                  controller.container?.destroy();
                },
                routineWait: async (second) => {
                  await new Promise((resolve) => {
                    const ticker = app.ticker;
                    let current = 0;
                    const onUpdate = (elapsedTime) => {
                      const deltaTime = (1 / ticker.FPS) * ticker.speed;
                      current += deltaTime;
                      if (current > second) {
                        ticker.remove(onUpdate);
                        resolve();
                      }
                    };
                    ticker.add(onUpdate);
                  });
                },
              };
              character.controller = controller;
              resolve(controller);
            } else {
              reject({ error: "NO_SPINE_DATA_Zeke" });
            }
          });
        }),
      ];
      Promise.all(promises)
        .then((results) => {
          const [character] = results;
          resolve(character);
        })
        .catch((e) => {
          Sentry.captureException(e);
          reject(e);
        });
    });
  },
};

export default character;
